import SplitText from '@/components/SplitText'

export default
{
    name: 'home',

    components: {
        SplitText
    },

    mounted()
    {
        requestAnimationFrame(() => this.$el.classList.remove('is-page-before'))
    }
}
